import React from 'react';

function DaysMonth(props) {

    const res = (props._data) ? props._data.filter((el) => el.id < 0) : 0;

    const GridDataDays = (props) =>
        props._data.days.map((it, index) => <div className="name_day common" key={index}>{it}</div>);


    return (
        <>
            {
                ((res) ?
                    res.map((item, index) =>
                        <div className="rec_calendar" key={index}>
                            <div className="num_room common">
                                &nbsp;&nbsp;&nbsp;
                            </div>
                            <GridDataDays _data={item}/>
                        </div>
                    )
                    :
                    <></>)
            }
        </>
    );
}

export default DaysMonth;
